import React from "react";
import { func, bool } from "prop-types";

import Checkbox from "../../../common/Checkbox/index";
import * as style from "./styles.module.scss";

const WorkTypeOptions = ({
  hasSelectedPermanent,
  hasSelectedTemporary,
  toggleType,
}) => (
  <div>
    Work type
    <div className={`btn-group clearfix d-flex ${style.workForm__options}`}>
      <Checkbox
        label="Temp"
        isChecked={hasSelectedTemporary}
        onClick={() => toggleType("temp")}
        classes={`${style.workForm__input}`}
      />
      <Checkbox
        label="Permanent"
        isChecked={hasSelectedPermanent}
        onClick={() => toggleType("permanent")}
        classes={`${style.workForm__input}`}
      />
    </div>
  </div>
);

WorkTypeOptions.propTypes = {
  hasSelectedPermanent: bool.isRequired,
  hasSelectedTemporary: bool.isRequired,
  toggleType: func.isRequired,
};

export default WorkTypeOptions;
